import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

// Function to get the anonId cookie
export const getAnonId = () => {
    let anonId = Cookies.get('anonId');
    if (!anonId) {
        anonId = setAnonId();
    }
    return anonId;
};

// Function to set the anonId cookie with a 10-day expiration
export const setAnonId = () => {
    const anonId = uuidv4();
    Cookies.set('anonId', anonId, { expires: 10, sameSite: 'None', secure: true }); // Set cookie to expire in 10 days with SameSite=None and Secure
    return anonId;
};

// Function to set the anonId cookie with a 10-day expiration
export const setTableNrCookie = (tableNumber) => {
    Cookies.set('tableNumber', tableNumber, { expires: 10, sameSite: 'None', secure: true }); // Set cookie to expire in 10 days with SameSite=None and Secure
    return tableNumber;
};

// Function to get the anonId cookie
export const getTableNrCookie = () => {
    return Cookies.get('tableNumber');
};

